import './calloutBox.scss';

export function calloutBox(){
	// for mobile expansion, otherwise collapse
	function expandBox(){
		let btn = document.querySelectorAll(".callout--btn");

		btn.forEach(x => {
			x.addEventListener("click", e => {
				e.target.blur();
				let container = x.parentElement.querySelector(".callout--below-the-fold"),
					items = x.parentElement.querySelectorAll(".callout--below-the-fold > *"),
					height = 0;

				if (x.classList.contains("callout__open")) {
					x.classList.remove("callout__open");
					x.querySelector("span").innerText = "Continue reading";

					container.style = null;

				} else {
					x.classList.add("callout__open");

					items.forEach(y => {
						let styles = window.getComputedStyle(y),
							margin = styles.getPropertyValue('margin').split('px')[0];

						console.log(margin);
						height = height + y.offsetHeight + (Number(margin) * 1.5);
					})

					container.style.height = height + "px";
					x.querySelector("span").innerText = "Show less";
				} 
			});
		});
	}

	expandBox();
}
